export default {

  state () {
    return {
      loading: false
    }
  },

  actions: {
    setLoading (context, payload) {
      context.commit('SET_LOADING', payload)
    }
  },

  mutations: {
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },

  getters: {
    loading: state => state.loading
  }
}